// extracted by mini-css-extract-plugin
export default {"commentButton":"CommentButtonStyles_commentButton__RSHp1"};